export function AsociadosPage() {
  return (
    <section>
      <header className="pageHeader">
        <h1 className="heading-3">Asociados</h1>
        <p className="text-element-mid">
          ABM individual + edición granular fila por fila (registra audit log).
        </p>
      </header>
      <div className="card" style={{ marginTop: '1.5rem' }}>
        <p className="text-element-mid">Tabla con filtros — en construcción.</p>
      </div>
    </section>
  );
}
